import { render, staticRenderFns } from "./RegionNosologiaPage.vue?vue&type=template&id=38f1657a&"
import script from "./RegionNosologiaPage.vue?vue&type=script&lang=js&"
export * from "./RegionNosologiaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports